const { documentReady, windowLoaded } = require('@grpn/document-states');
const { removeDuplicateCookies } = require('../../../../src/frontend/core/cookie-monster');
require('src/frontend/vendor/md5');

require('src/frontend/core/grouponDesktopObject-v7');
const I18n = require('node_modules/grapefruit/lib/I18n');

const dataSet = document.head.dataset;
const options = {
  country: dataSet.country,
  locale: dataSet.locale,
  lang: dataSet.lang,
};
window.I18n = new I18n(options);

require('src/frontend/lazyload/lazyLoadImages');

documentReady.then(() => {
  Groupon.Utils.lazyLoadImages();
});

windowLoaded.then(() => {
  removeDuplicateCookies();
});
